import { Button, GoogleColoredIcon } from '@iheartjane/reefer';
import type { ButtonProps } from '@iheartjane/reefer';

interface GoogleButtonProps extends ButtonProps {
  label: string;
  loaded: boolean | undefined;
  onClick: () => void;
}

const GoogleSignInButton = ({
  onClick,
  loaded,
  label,
  ...buttonProps
}: GoogleButtonProps) => {
  return (
    <Button
      disabled={!loaded}
      full
      label={label}
      onClick={onClick}
      startIcon={<GoogleColoredIcon size="sm" color={null} />}
      variant="tertiary"
      {...buttonProps}
    />
  );
};

export default GoogleSignInButton;
